import { VALTYPES, VALTYPE_ANY } from '../../../../data/interfaces';
import { createColorMappingAspect, createColorMappingConfigs } from '../../helpers/colorMappingInfo';
import { createConfigParamTypeRange } from '../../helpers/configParams';
import { TpChartManifest } from '../interfaces';
import { Network } from './Network';

export const manifestNetwork: TpChartManifest = {
  id: 'Network',
  name: 'Network',
  description: `Displays a network with nodes and connecting edges. The nodes can be color-coded by a property.

Example usage:
- Display a protein-protein interaction network.

In addition to the data table that defines the nodes, this plot also needs a data table defining the edges.
That should be a table for which the \`relationsForEntity\` is set to the canonical type identifier of the nodes table.
On that edges table, the parameters \`relationFrom\` and \`relationTo\` should be set to define the columns that hold the node identifies defining each edge.
`,
  component: Network,
  canvasBased: true,
  groups: [
    { groupId: 'position', groupName: 'Position' },
    { groupId: 'pointColor', groupName: 'Point color' },
    { groupId: 'pointLayout', groupName: 'Point layout' },
    { groupId: 'edgeLayout', groupName: 'Edges layout' },
  ],
  aspects: [
    {
      id: 'x',
      name: 'X axis',
      description: 'Precomputed X coordinates of the nodes',
      groupId: 'position',
      required: true,
      quality: 1,
      dataType: [VALTYPES.NUMBER, VALTYPES.INTEGER],
    },
    {
      id: 'y',
      name: 'Y axis',
      description: 'Precomputed Y coordinates of the nodes',
      groupId: 'position',
      required: true,
      quality: 0.95,
      dataType: [VALTYPES.NUMBER, VALTYPES.INTEGER],
    },
    {
      id: 'size',
      name: 'Point size data',
      description: 'Scaling factor for the overall size of the nodes.',
      groupId: 'pointLayout',
      required: false,
      quality: 0.25,
      dataType: [VALTYPES.NUMBER, VALTYPES.INTEGER],
    },
    createColorMappingAspect('color', 'Point color data', 'pointColor', 0.5, 'network nodes'),
    {
      id: 'hoverLabel',
      name: 'Hover label',
      description: 'Text to be displayed when the mouse hovers over a node.',
      groupId: 'pointLayout',
      required: false,
      dataType: VALTYPE_ANY,
    },
  ],
  configParams: [
    {
      id: 'pointSizeFactor',
      name: 'Point size',
      description: 'Scaling factor for the overall size of the nodes in the plot.',
      groupId: 'pointLayout',
      paramType: createConfigParamTypeRange(0.2, 4, 0.1, 3),
    },
    {
      id: 'opacity',
      name: 'Point Opacity',
      description: `Node opacity.
In case a plot contains many overlapping nodes, lowering the opacity (i.e. increasing transparency)
can help reveal the data structure.`,
      groupId: 'pointLayout',
      paramType: createConfigParamTypeRange(0.1, 1, 0.1, 1),
    },
    {
      id: 'edgeDarkness',
      name: 'Edge Darkness',
      groupId: 'edgeLayout',
      paramType: createConfigParamTypeRange(0.1, 1, 0.05, 0.4),
    },
    {
      id: 'edgeOpacity',
      name: 'Edge Opacity',
      groupId: 'edgeLayout',
      paramType: createConfigParamTypeRange(0.0, 1, 0.05, 0.85),
    },
    ...createColorMappingConfigs('color', 'Color', 'pointColor'),
  ],
  examples: [
    {
      id: 'network_1',
    },
  ],
};
